import { put, select } from "redux-saga/effects";
import { API } from 'aws-amplify';
import { getResponseData } from '../../utils/apiHelpers';
import moment from "moment";

import * as actions from "../actions";
import * as selectors from "../selectors/selectors";

import layers from '../../views/DashboardV2/Dummydata/Lyslayers';
import { handleApiError } from '../../utils/apiErrorHandler';

const kryGrondvog = async (params) => {
    let apiName = 'AWSApiGateway';
    let path = `/grondvog${params ? "?" + params.join("&") : "?aantaldae=7"}`;
    const response = await API.get(apiName, path, { response: true });
    // console.log(response);
    var lesings = [...getResponseData(response, [])];
    for (var lesing of lesings) {
        lesing.value = lesing.gradering;
        lesing.coordinates = { lat: lesing.lat, lng: lesing.lon };
        lesing.date = lesing.datumtyd;
        lesing.capturer = lesing.arbeider.naam;
        delete lesing.lat;
        delete lesing.lon;
        delete lesing.gradering;
        delete lesing.arbeider;
        delete lesing.akkuraatheid;
    }
    // console.log(lesings);
    return lesings;
}

const kryOesskatting = async (params) => {
    try {
        let apiName = 'API_Aktiwiteite';
        let path = `/oesskatting${params ? "?" + params.join("&") : "?aantaldae=7"}`;
        const response = await API.get(apiName, path, { response: true });
        // console.log(response);
        var lesings = [...getResponseData(response, [])];
        for (var lesing of lesings) {
            lesing.value = lesing.waarde;
            lesing.coordinates = lesing.posisie;
            lesing.date = lesing.datumtyd;
            lesing.capturer = lesing.werknemer.naam;
            delete lesing.bnr;
            delete lesing.waarde;
            delete lesing.posisie;
            delete lesing.werknemer;
        }
        return lesings;
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        throw errordata;
    }
}

const kryOnkruid = async (params) => {
    try {
        let apiName = 'API_Aktiwiteite';
        let path = `/onkruidverkenning${params ? "?" + params.join("&") : "?aantaldae=7"}`;
        const response = await API.get(apiName, path, { response: true });
        // console.log(response);
        var lesings = [...getResponseData(response, [])];
        for (var lesing of lesings) {
            lesing.value = lesing.waarde;
            lesing.coordinates = lesing.posisie;
            lesing.date = lesing.datumtyd;
            lesing.capturer = lesing.werknemer.naam;
            delete lesing.posisie;
            delete lesing.datumtyd;
            delete lesing.werknemer;
        }
        return lesings;
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        throw errordata;
    }
}

export function* getLayerslysSaga(action) {
    try {
        var layer = [...layers];
        // console.log(layer);
        yield put(actions.setLayerslys(layer));
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.getLayerslysFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}

export function* kiesLayerSaga(action) {
    try {
        const aktiewelayers = yield select(selectors.layersAkief);
        var lesings;
        if (aktiewelayers.indexOf(action.key) > -1) {
            if (action.key === 1) {
                lesings = yield kryGrondvog();
            }
            if (action.key === 2) {
                lesings = yield kryOesskatting();
            }
            if (action.key === 3) {
                lesings = yield kryOnkruid();
            }
            yield put(actions.setLayers({ id: action.key, data: lesings }));
        } else {
            yield put(actions.removeLayer(action.key));
        }
    } catch (error) {
        console.log(error);
    }
}

export function* veranderLayerFilterSaga(action) {
    try {
        const aktiewelayers = yield select(selectors.layersAkief);
        var params = [];
        var lesings;
        if (aktiewelayers.indexOf(action.key) > -1) {
            if (action.tipe === "daterange") {
                params.push("begindatum=" + moment(action.nuwewaarde[0]).endOf("day").format("Y-MM-DD HH:mm:ss"));
                params.push("einddatum=" + moment(action.nuwewaarde[1]).endOf("day").format("Y-MM-DD HH:mm:ss"));
            }
            if (action.key === 1) {
                lesings = yield kryGrondvog(params);
            }
            if (action.key === 2) {
                lesings = yield kryOesskatting(params);
            }
            if (action.key === 3) {
                lesings = yield kryOnkruid(params);
            }
            yield put(actions.setLayers({ id: action.key, data: lesings }));
        } else {
            yield put(actions.removeLayer(action.key));
        }
    } catch (error) {
        console.log(error);
    }
}